<template>
  <div>
    <div v-if="locations.length > 0" class="flex align-items-center gap-x-xs p-x-md p-y-sm">
      <label for="roster-location-filter" class="m-b-none text-small font-normal text-gray-600">Location</label>
      <select
        id="roster-location-filter"
        v-model="selectedLocationId"
        class="form-control input-sm"
        style="width: auto;"
        aria-label="Filter rosters by location"
        data-cy="roster-location-filter"
      >
        <option :value="null">All locations</option>
        <option v-for="location in locations" :key="location.id" :value="location.id">
          {{ location.name }}
        </option>
      </select>
    </div>
    <paged-list
      response-key="rosters"
      object-type="Roster"
      :base-url="baseUrl"
      :load-per-page="12"
      :manual-paging="true"
      empty-text="No rosters found"
      container-class="roster-grid grid grid-cols-4 sm-grid-cols-1 md-grid-cols-2 border"
      :ransack-params="{ q: { archived_eq: false, s: 'name asc' } }"
    >
      <template v-slot:list="slotProps">
        <roster :roster="slotProps.result" :show-edit="showEdit"></roster>
      </template>
    </paged-list>
  </div>
</template>
<script>
import PagedList from './paged_list.vue';
import Roster from './roster.vue';

export default {
  name: 'filtered-roster-list',
  components: { PagedList, Roster },
  props: {
    showEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locations: [],
      selectedLocationId: null,
    };
  },
  computed: {
    // paged-list watches base-url and re-fetches when it changes. Rails merges the
    // repeated q[...] keys, so location_id_eq here combines with the archived/sort
    // ransack params below.
    baseUrl() {
      const base = '/api/v1/rosters';
      if (this.selectedLocationId) {
        return `${base}?q[location_id_eq]=${this.selectedLocationId}`;
      }
      return base;
    },
  },
  mounted() {
    this.getLocations();
  },
  methods: {
    getLocations() {
      const vm = this;
      vm.$apiService.loadAllPages(vm.$apiService.locationsUrl(), 'locations')
        .then((locations) => {
          vm.locations = locations;
        })
        .catch(() => {
          // Non-fatal: without locations the filter simply doesn't render.
          vm.locations = [];
        });
    },
  },
};
</script>
